module.exports = __webpack_public_path__ + "static/ecommerce-cbdeaff818dd3d24730623c745e49a28.svg";